import { createApp } from 'vue'

// src/main.js
// import Vue from 'vue';
import App from './App.vue';
import router from './router';

// Vue.config.productionTip = false;

// new Vue({
//   router,
//   render: h => h(App),
// }).$mount('#app');


const app = createApp(App);

// Use the router
app.use(router);

app.mount('#app');
